import axios from 'axios';

const http = axios.create({
	baseURL: dcuk.api_url,
});

export default http;